import { X } from 'lucide-react';
import { useAiGatewayHealth } from '@/contexts/AiGatewayHealthContext';

/**
 * Calm app-wide banner shown when the Lovable AI Gateway has returned a
 * credits-exhausted response in the last ~30 min. Tone follows rateLimitCopy.ts:
 * reassures, never says "error", no em-dashes.
 */
export function AiGatewayBanner() {
  const { status, dismissed, dismiss } = useAiGatewayHealth();

  if (status !== 'depleted' || dismissed) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="w-full bg-amber-50 border-b border-amber-200 px-4 py-2.5 text-sm text-amber-900 flex items-center justify-center gap-3"
    >
      <span className="font-medium">
        Our AI engine is briefly catching up.
      </span>
      <span className="text-amber-800/80 hidden sm:inline">
        Your work is safe. New analyses may pause for a few minutes.
      </span>
      <button
        onClick={dismiss}
        aria-label="Dismiss"
        className="ml-2 p-1 rounded hover:bg-amber-100 transition-colors"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
